import * as React from "react"
export const Svg_015 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={59}
    height={59}
    fill="none"
  >
    <g clipPath="url(#a)">
      <path
        fill="url(#b)"
        d="m3.712 37.35 17.982-17.982a12.597 12.597 0 0 1 8.943-3.69 12.697 12.697 0 0 1 5.565 1.282 12.652 12.652 0 0 1 3.404 2.43c.71.71 1.328 1.494 1.847 2.341l-4.673 4.673a6.387 6.387 0 0 0-1.584-2.603 6.375 6.375 0 0 0-4.538-1.88 6.375 6.375 0 0 0-4.538 1.88L8.141 41.78a6.425 6.425 0 0 0 0 9.075 6.376 6.376 0 0 0 4.538 1.88 6.375 6.375 0 0 0 4.538-1.88l5.21-5.21a16.151 16.151 0 0 0 5.936 1.128c.642 0 1.278-.037 1.907-.11l-8.623 8.622A12.599 12.599 0 0 1 12.679 59a12.6 12.6 0 0 1-8.967-3.715c-4.945-4.944-4.945-12.99 0-17.935Z"
      />
      <path
        fill="url(#c)"
        d="M37.27 39.662a12.595 12.595 0 0 1-8.907 3.655c-1.379 0-2.738-.221-4.04-.657a17.216 17.216 0 0 1-1.769-.745 12.606 12.606 0 0 1-3.16-2.312 12.692 12.692 0 0 1-1.85-2.338l4.676-4.675a6.387 6.387 0 0 0 1.584 2.603 6.375 6.375 0 0 0 4.538 1.88 6.375 6.375 0 0 0 4.538-1.88l17.979-17.979a6.375 6.375 0 0 0 1.88-4.537 6.375 6.375 0 0 0-1.88-4.538 6.375 6.375 0 0 0-4.538-1.88 6.376 6.376 0 0 0-4.538 1.88l-5.174 5.174-.036.036a16.148 16.148 0 0 0-5.936-1.128c-.642 0-1.278.037-1.907.11l8.623-8.622c4.945-4.945 12.99-4.945 17.936 0 4.944 4.945 4.944 12.99 0 17.935l-17.96 17.96-.059.058Z"
      />
    </g>
    <defs>
      <linearGradient
        id="b"
        x1={9.588}
        x2={30.561}
        y1={22.176}
        y2={54.651}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={27.131}
        x2={48.099}
        y1={6.498}
        y2={38.972}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h59v59H0z" />
      </clipPath>
    </defs>
  </svg>
)